import { render, staticRenderFns } from "./MeetingRegisterMandateRepresentant.vue?vue&type=template&id=4a54eee3&"
import script from "./MeetingRegisterMandateRepresentant.vue?vue&type=script&lang=js&"
export * from "./MeetingRegisterMandateRepresentant.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports